// src/services/foSegmentBOQService.js - NO ESLINT WARNING
import api from '../config/axios';

const BASE_PATH = '/fo-segment-boq';

// ============= Query Operations =============

/**
 * Check if segment has BOQ
 * ✅ NEW: For checking BOQ existence
 */
export const checkBOQExists = async (segmentId) => {
  const response = await api.get(`${BASE_PATH}/segment/${segmentId}/exists`);
  return response.data.exists;
};

/**
 * Get BOQ by segment ID (returns first/most recent BOQ)
 * ✅ UPDATED: Now returns single BOQ, not array
 */
export const getBOQBySegmentId = async (segmentId) => {
  const timestamp = new Date().getTime();
  const response = await api.get(`${BASE_PATH}/segment/${segmentId}?_t=${timestamp}`);
  return response.data;
};

/**
 * Get all BOQs for a segment (if you need multiple categories)
 * Note: Current backend returns single BOQ, not array
 */
export const getBOQsBySegmentId = async (segmentId) => {
  const response = await api.get(`${BASE_PATH}/segment/${segmentId}`);
  // Return as array for backward compatibility
  return Array.isArray(response.data) ? response.data : [response.data];
};

/**
 * Get BOQ by segment and category
 */
export const getBOQBySegmentAndCategory = async (segmentId, categoryId) => {
  const response = await api.get(`${BASE_PATH}/segment/${segmentId}/category/${categoryId}`);
  return response.data;
};

/**
 * Get BOQ by ID
 */
export const getBOQById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

// ============= Command Operations =============

/**
 * Create or Update BOQ
 * If BOQ exists for segment+category, updates it. Otherwise creates new.
 */
export const saveBOQ = async (boqData) => {
  const response = await api.post(BASE_PATH, boqData);
  return response.data;
};

/**
 * Delete BOQ
 */
export const deleteBOQ = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

/**
 * Approve BOQ
 */
export const approveBOQ = async (id) => {
  const response = await api.post(`${BASE_PATH}/${id}/approve`);
  return response.data;
};

/**
 * Unapprove BOQ
 */
export const unapproveBOQ = async (id) => {
  const response = await api.post(`${BASE_PATH}/${id}/unapprove`);
  return response.data;
};

// ✅ FIXED: Assign to variable before export
const foSegmentBOQService = {
  checkBOQExists,
  getBOQBySegmentId,
  getBOQsBySegmentId,
  getBOQBySegmentAndCategory,
  getBOQById,
  saveBOQ,
  deleteBOQ,
  approveBOQ,
  unapproveBOQ
};

export default foSegmentBOQService;